module.exports = __webpack_public_path__ + "static/media/capture_border_green.64cc4db3.png";